import React from "react"
import { SITE_TITLE } from "shared/constants/textConstants"
import css from "./Title.module.scss"

export const Title = () => {
  return <h1 className={css.title}>{SITE_TITLE}</h1>
}
